import { ajax, ajaxAsync } from "./communication/AjaxHelper";
import { BaseResponse, CRUDPruefungRequest, CRUDPruefungResponse, GetPruefungStudentStatesRequest, GetPruefungStudentStatesResponse, GetPruefungStudentTableDataRequest, GetPruefungStudentTableDataResponse, GetPruefungenForLehrkraftResponse, KlassData, Pruefung, PruefungCaptions, PruefungState, PruefungStudentMode, UpdatePruefungSchuelerDataRequest, UserData, WorkspaceShortData, type GradeData } from "./Data";
import { PushClientManager } from "./communication/pushclient/PushClientManager";
import { w2grid, w2ui, w2utils, w2field } from 'w2ui';
import { GUIButton } from "./tools/GUIButton";
import { makeDiv } from "./tools/HtmlTools";
import { AdminMenuItem } from "./AdminMenuItem";
import { NewPruefungPopup } from "./NewPruefungPopup";
import jQuery from 'jquery';
import { AdminMessages } from "./AdministrationMessages";
import { Administration } from "./Administration";


type GetPruefungForPrintingRequest = {
    pruefungId: number
}

type PFileData = {
    id: number;
    name: string;
    text: string;
    text_before_revision?: string
}

type PSchuelerData = {
    id: number;
    rufname: string;
    familienname: string;
    username: string;
    grade?: string;
    points?: string;
    comment?: string;
    mode: PruefungStudentMode | { id: PruefungStudentMode, text: string };
    group?: string | { id: string, text: string };
    files: PFileData[];

    state?: string;

}

type GetPruefungForPrintingResponse = {
    success: boolean,
    message: string,
    pSchuelerDataList: PSchuelerData[];
    templates: PFileData[];
}


export class Pruefungen extends AdminMenuItem {

    states: PruefungState[] = ["preparing", "running", "correcting", "opening"];
    stateIndex: { [key in PruefungState]: number } = {
        preparing: 0,
        running: 1,
        correcting: 2,
        opening: 3
    };


    pruefungen: Pruefung[];
    klassen: KlassData[];
    workspaces: WorkspaceShortData[];

    pruefungTable: w2grid;
    studentTable: w2grid;

    $stateDiv: JQuery<HTMLDivElement>;
    buttonBack: GUIButton;
    buttonForward: GUIButton;

    selectedStateIndex: number;
    currentPruefung: Pruefung;

    oldPruefung: Pruefung;

    counter: number = 0;

    timerActive: boolean = false;

    fieldGroupA: w2field;
    fieldGroupB: w2field;

    $messagesDiv: JQuery<HTMLDivElement>;

    constructor(administration: Administration) {
        super(administration);
        this.identifier = "manageTests";
    }

    getButtonIdentifier(): string {
        return AdminMessages.manageTests();
    }

    async onMenuButtonPressed($mainHeading: JQuery<HTMLElement>, $tableLeft: JQuery<HTMLElement>, $tableRight: JQuery<HTMLElement>, $mainFooter: JQuery<HTMLElement>): Promise<void> {

        //@ts-ignore
        w2utils.settings.dateEndYear = 2050;
        //@ts-ignore
        w2utils.settings.dateStartYear = 1990;

        let response = await ajaxAsync("/servlet/getPruefungenForLehrkraft", {}) as GetPruefungenForLehrkraftResponse;
        if (response == null) return;
        this.pruefungen = response.pruefungen;
        this.klassen = response.klassen;
        this.workspaces = response.workspaces;
        this.workspaces = this.workspaces.sort((wsa, wsb) => { return wsa.name.localeCompare(wsb.name) });

        this.workspaces.forEach(ws => ws.text = this.getWorkspaceNameWithFolder(ws));

        this.workspaces.unshift({
            name: AdminMessages.noTemplateWorkspace(),
            text: AdminMessages.noTemplateWorkspace(),
            parent_folder_id: null,
            isFolder: false,
            id: -1,
            files: [],
            sorting_order: -1
        })

        for (let p of this.pruefungen) {
            p["klasse"] = this.klassen.find((c) => c.id == p.klasse_id)?.text;
        }

        $tableLeft.css('flex', '3');
        $tableRight.css('flex', '4');

        $tableLeft.empty();
        $tableRight.empty();
        
        let $rightPanel = jQuery(`<div class="jo_pruefung_right_panel"></div>`);
        let $rightTableDiv = jQuery(`<div class="jo_pruefung_right_table_outer"></div>`);
        let $rightMessagesDiv = jQuery(`<div class="jo_pruefung_right_message_outer"></div>`);

        $tableRight.append($rightPanel);
        $rightPanel.append($rightTableDiv, $rightMessagesDiv);

        $rightMessagesDiv.append(`<div class="jo_pruefung_right_message_header w2ui-grid-header">${AdminMessages.messages()}</div>`);
        $rightMessagesDiv.append(this.$messagesDiv = jQuery(`<div class="jo_pruefung_right_message_content"></div>`));

        this.setupGUI($tableLeft, $rightTableDiv);

        this.onUnselectPruefung();

        this.fillPruefungTable();

        this.initTimer();

        PushClientManager.getInstance().subscribe("onGradeChangedInMainWindow", (data: GradeData) => {
            let record: PSchuelerData = <any>this.studentTable.records.find((r: PSchuelerData) => r.id == data.user_id);
            if (record == null) return;
            record.grade = data.grade;
            record.points = data.points;
            this.studentTable.refreshRow(record["recid"]);
        })

        PushClientManager.getInstance().subscribe("messageWhilePruefungIsRunning", (data: string ) => {
            this.$messagesDiv.append(`<div>${data}</div>`);
        });

    }
    destroy() {
        this.pruefungTable.destroy();
        this.studentTable.destroy();
        this.timerActive = false;
        jQuery('.joe_pruefung_timerbar').remove();
        PushClientManager.getInstance().unsubscribe("onGradeChangedInMainWindow");
        PushClientManager.getInstance().unsubscribe("messageWhilePruefungIsRunning");
    }

    checkPermission(user: UserData): boolean {
        return user.is_teacher == true;
    }


    initTimer() {

        let $timerBar = makeDiv(null, 'joe_pruefung_timerbar', null, null, jQuery('#outer'));
        this.timerActive = true;

        let timer = async () => {
            if (!this.timerActive) return;

            setTimeout(timer, 1000);
            if (["running", "correcting"].indexOf(this.currentPruefung?.state) >= 0) {
                $timerBar.empty();
                for (let i = 0; i < 5 - this.counter % 5; i++) {
                    $timerBar.append(`<span class="joe_pruefung_timerspan"></span>`)
                }

                if (this.counter % 5 == 0 && this.currentPruefung != null) {
                    let request: GetPruefungStudentStatesRequest = { pruefungId: this.currentPruefung.id }

                    let pruefungStates = await ajaxAsync("/servlet/getPruefungStates", request) as GetPruefungStudentStatesResponse;
                    if (pruefungStates != null) {
                        this.displayStudentStates(pruefungStates);
                    }
                }
                this.counter++;

            } else {
                $timerBar.empty();
            }
        }

        timer();
    }

    displayStudentStates(pruefungStates: GetPruefungStudentStatesResponse) {

        for (let record of this.studentTable.records as PSchuelerData[]) {
            let isOnline = pruefungStates.pruefungStudentStates.find(state => state.studentId == record.id)?.running;
            record.state = isOnline ? AdminMessages.running() : AdminMessages.stopped();
            this.studentTable.refreshCell(record["recid"], "state");
        }

    }

    resetStudentStates() {
        for (let record of this.studentTable.records as PSchuelerData[]) {
            record.state = null;
            this.studentTable.refreshCell(record["recid"], "state");
        }
    }

    setupGUI($tableLeft: JQuery<HTMLElement>, $tableRight: JQuery<HTMLElement>) {
        let that = this;

        $tableLeft.empty();
        $tableRight.empty();

        makeDiv("pruefungTable", null, null, null, $tableLeft);
        makeDiv("pruefungActions", null, null, null, $tableLeft);
        makeDiv("studentTable", null, null, null, $tableRight);

        w2ui["pruefungTable"]?.destroy();
        this.pruefungTable = new w2grid({
            name: "pruefungTable",
            header: AdminMessages.pruefungen(),
            multiSelect: false,
            show: {
                header: true,
                toolbar: true,
                toolbarDelete: true,
                toolbarAdd: true,
            },
            recid: "id",
            columns: [
                { field: 'id', text: 'ID', size: '20px', sortable: true, hidden: true },
                { field: 'name', text: AdminMessages.identifier(), size: '15%', sortable: true, resizable: true, editable: { type: 'text' } },
                {
                    field: 'klasse_id', text: AdminMessages.classWord(), size: '10%', sortable: true, resizable: true,
                    editable: { type: 'list', items: this.klassen, showAll: true, openOnFocus: true, align: 'left' },
                    render: (e) => {
                        return this.klassen.find(c => c.id == e.klasse_id).text
                    }
                },
                {
                    field: 'datum', text: AdminMessages.date(), size: '15%', sortable: true, resizable: true, editable: { type: 'date' },
                    render: (e) => {
                        return e.datum == null ? '----' : e.datum;
                    }
                },
                // {
                //     field: 'template_workspace_id', text: AdminMessages.templateWorkspace(), size: '25%', sortable: true, resizable: true,
                //     editable: {
                //         type: 'list', items: this.workspaces.filter(ws => !ws.isFolder), showAll: true, openOnFocus: true, align: 'left',
                //         style: 'width: 400px'
                //     },
                //     render: (e) => {
                //         let ws = this.workspaces.find(c => c.id == e.template_workspace_id);
                //         return ws == null ? AdminMessages.noTemplateWorkspace() : ws.text;
                //     }
                // },
                {
                    field: 'state', caption: AdminMessages.state(), size: '15%', sortable: true, resizable: true,
                    render: (e, extra) => `<div class="jo_pruefung_state_cell">
                    <div class="jo_pruefung_state_cell_icon img_test-state-${e.state}"></div>
                    <div class="jo_pruefung_state_text">${PruefungCaptions[e.state]}</div></div>`
                }
            ],
            sortData: [{ field: 'klasse', direction: 'ASC' }, { field: 'name', direction: 'ASC' }],
            onSelect: (event) => {
                setTimeout(() => {
                    this.onSelectPruefung(event.detail.recid || event.detail.clicked.recid)
                }, 100);
            },
            onDelete: (event) => {
                let selected = this.pruefungTable.getSelection();
                let pruefung = this.pruefungen.find(p => p.id == selected[0]);
                if (pruefung.state == "running") {
                    event.isCancelled = true;
                    alert(AdminMessages.testCantBeDeleted());
                    return;
                }
                event.done(async (e) => {
                    this.deletePruefung(<number>selected[0])
                })
            },
            onAdd: (event) => { this.addPruefung() },
            onChange: (event) => { this.onUpdatePruefung(event) }
        })

        this.pruefungTable.render(jQuery('#pruefungTable')[0]);

        //@ts-ignore
        let oldGetCellEditable: (ind: number, col_ind: number) => any = this.pruefungTable.getCellEditable;

        //@ts-ignore
        this.pruefungTable.getCellEditable = (ind: number, col_ind: number) => {
            let record = this.pruefungTable.records[ind];
            if (col_ind != 1 && col_ind != 3 && record['state'] != 'preparing') {
                return null;
            } else {
                return oldGetCellEditable.call(this.pruefungTable, ind, col_ind);
            }
        }


        w2ui["studentTable"]?.destroy();

        this.studentTable = new w2grid({
            name: "studentTable",
            header: AdminMessages.students(),
            show: {
                header: true
            },
            recid: "id",
            columnGroups: [
                { span: 3, text: "Name" },
                { span: 2, text: "Leistung" },
                { span: 2, text: "Modus" },
                { span: 1, text: "Zustand" }
            ],
            columns: [
                { field: 'id', text: 'ID', size: '20px', sortable: true, hidden: true },
                { field: 'name', text: AdminMessages.sname(), size: '20%', sortable: true, resizable: true, sortMode: 'i18n' },
                { field: 'username', text: AdminMessages.username(), size: '20%', sortable: true, resizable: true, sortMode: 'i18n' },
                { field: 'grade', text: AdminMessages.markShort(), tooltip: AdminMessages.mark(), size: '5%', sortable: true, resizable: true, editable: { type: "text" } },
                { field: 'points', text: AdminMessages.pointsShort(), tooltip: AdminMessages.points(), size: '5%', sortable: true, resizable: true, editable: { type: "text" } },
                // {
                //     field: 'manual', text: AdminMessages.manual(), size: '13%', sortable: true, resizable: true,
                //     editable: { type: 'checkbox', style: 'text-align: center' }
                // },
                {
                    field: 'mode', text: AdminMessages.modeShort(), size: '13%', sortable: true, resizable: true,
                    editable: {
                        type: 'list', items: [
                            { id: 'automatic', text: "Normal" }, { id: 'manualOff', text: "Abwesend" }, { id: 'manualOn', text: "Verlängert" }
                        ], showAll: true, openOnFocus: true, align: 'left'
                    },
                    render(record, extra) {
                        return extra.value?.text || '';
                    }
                },
                {
                    field: 'group', text: AdminMessages.groupShort(),
                    tooltip: AdminMessages.groupLong(), size: '5%', sortable: true, resizable: true,
                    editable1: {
                        type: 'list', items: [
                            { id: 'A', text: "A" }, { id: 'B', text: "B" }
                        ], showAll: true, openOnFocus: true, align: 'left'
                    },
                    render(record, extra) {
                        return extra.value?.text || '';
                    }

                },
                // {
                //     field: 'attended_exam', text: AdminMessages.attendanceShort(), tooltip: AdminMessages.attendance(), size: '10%', sortable: true, resizable: true,
                //     editable: { type: 'checkbox', style: 'text-align: center' }
                // },
                // see https://w2ui.com/web/docs/2.0/w2grid.columns
                {
                    field: 'state', text: AdminMessages.state(), size: '15%', sortable: true, resizable: true,
                    render: (record: PSchuelerData) => {
                        let state = record.state;
                        if (state == null) state = "---";
                        switch (state) {
                            case AdminMessages.running(): return `<div class='jo_stateOnline'>${AdminMessages.running()}</div>`;
                            case AdminMessages.stopped(): return `<div class='jo_stateOffline'>${AdminMessages.stopped()}</div>`;
                            case "---": return "---"
                        }

                    }
                },

            ],
            sortData: [{ field: 'name', direction: 'ASC' }, { field: 'username', direction: 'ASC' }],
            onSelect: (event) => { event.done((e) => { }) },
            onChange: (event) => { this.onUpdateStudent(event) }
        })

        this.studentTable.render(jQuery('#studentTable')[0]);

        // Actions
        let $actionsDiv = jQuery('#pruefungActions');



        makeDiv(null, 'jo_action_caption', AdminMessages.templateWorkspacesCaption(), null, $actionsDiv);

        let $detailsDiv = makeDiv(null, "jo_pruefung_details_div", "", null, $actionsDiv);
        let $firstLine = jQuery(`<div class="w2ui-field">
            <label>${AdminMessages.groupA()}</label>
            <div>
            <input type="list" placeholder="Type to search" style="width: 300px">
            </div>
            </div>`);
        let $secondLine = jQuery(`<div class="w2ui-field">
            <label>${AdminMessages.groupB()}</label>
            <div>
            <input type="list" placeholder="Type to search" style="width: 300px">
            </div>
            </div>`);
        $detailsDiv.append($firstLine, $secondLine);

        this.fieldGroupA = new w2field('list', {
            el: $firstLine.find('input[type=list]')[0],
            items: this.workspaces.filter(ws => !ws.isFolder).sort((wsa, wsb) => {
                return wsa.text.localeCompare(wsb.text);
            }),
            match: 'contains',
            markSearch: true,
            onSelect(event) {
                that.currentPruefung.template_workspace_a_id = event.detail.item.id;
                that.savePruefung();
            }
        })

        this.fieldGroupB = new w2field('list', {
            el: $secondLine.find('input[type=list]')[0],
            items: this.workspaces.filter(ws => !ws.isFolder).sort((wsa, wsb) => {
                return wsa.text.localeCompare(wsb.text);
            }),
            match: 'contains',
            markSearch: true,
            onSelect(event) {
                that.currentPruefung.template_workspace_b_id = event.detail.item.id;
                that.savePruefung();
            }
        })


        makeDiv(null, 'jo_action_caption', AdminMessages.stateOfSelectedTest(), null, $actionsDiv);

        this.$stateDiv = jQuery(`<div style="display: flex; flex-direction: column; width: 400px">
            <div style="display: flex; flex-direction: row; justify-content: space-between">
            <div class="pruefungState" id="joe_z0">${AdminMessages.preparation()}</div><div class="img_arrow-right-blue"></div>
            <div class="pruefungState" id="joe_z1">${AdminMessages.testRunning()}</div><div class="img_arrow-leftright-blue"></div>
            <div class="pruefungState" id="joe_z2">${AdminMessages.correction()}</div><div class="img_arrow-leftright-blue"></div>
            <div class="pruefungState" id="joe_z3">${AdminMessages.issueTest()}</div>
            </div>
            </div>
        `)

        let $leftRightButtonDiv = jQuery(`<div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 5px"></div>`);
        this.buttonBack = new GUIButton("<- " + AdminMessages.stateBack(), $leftRightButtonDiv);
        this.buttonForward = new GUIButton(AdminMessages.stateForward() + " ->", $leftRightButtonDiv);

        this.$stateDiv.append($leftRightButtonDiv);

        $actionsDiv.append(this.$stateDiv);

        let lastTimeClicked: number = 0;
        this.buttonBack.onClick(async () => {
            if (performance.now() - lastTimeClicked < 1000) return;
            lastTimeClicked = performance.now();
            if (this.selectedStateIndex == 1) {
                alert(AdminMessages.cantSetTestToState(PruefungCaptions[0]));
                return;
            }
            if (this.selectedStateIndex == 2) {
                if (!confirm(AdminMessages.sureToStartTestAgain())) return;
            }

            let oldState = this.selectedStateIndex;

            this.selectedStateIndex--;
            this.currentPruefung.state = this.states[this.selectedStateIndex];
            if (await this.savePruefung()) {
                this.renderState();
                this.resetStudentStates();
            } else {
                this.selectedStateIndex = oldState;
                this.currentPruefung.state = this.states[this.selectedStateIndex];
            }

            that.updatePruefungTable();
        })


        this.buttonForward.onClick(async () => {
            if (performance.now() - lastTimeClicked < 1000) return;
            lastTimeClicked = performance.now();
            if (this.selectedStateIndex == 0) {
                if (!confirm(AdminMessages.sureToStartTest())) return;
            }

            let oldState = this.selectedStateIndex;

            this.selectedStateIndex++;
            this.currentPruefung.state = this.states[this.selectedStateIndex];
            if (await this.savePruefung()) {
                this.renderState();
                this.resetStudentStates();
            } else {
                this.selectedStateIndex = oldState;
                this.currentPruefung.state = this.states[this.selectedStateIndex];
            }

            that.updatePruefungTable();

        })

        let $actions2Div = makeDiv(null, "joe_pruefung_actionsDiv", "", null, $actionsDiv);

        makeDiv(null, 'jo_action_caption', AdminMessages.actionsForSelectedTest(), null, $actions2Div);

        let $actionButtonsDiv = makeDiv(null, "joe_pruefung_actionButtonsDiv", "", null, $actions2Div);


        new GUIButton(" " + AdminMessages.printAll(), $actionButtonsDiv, "#5050ff", () => {
            this.print();
        });



    }

    getWorkspaceNameWithFolder(ws: WorkspaceShortData): string {
        let s: string = ws.name;
        if (ws.parent_folder_id) {
            let parent = this.workspaces.find(ws1 => ws1.id == ws.parent_folder_id);
            if (parent) {
                s = this.getWorkspaceNameWithFolder(parent) + "/" + s;
            }
        }
        return s;
    }

    updatePruefungTable() {
        this.pruefungTable.refresh();
    }

    async deletePruefung(pruefungId: number) {
        if (this.currentPruefung?.id == pruefungId) {
            this.currentPruefung = null;
        }
        let request: CRUDPruefungRequest = { requestType: "delete", pruefung: this.pruefungen.find(p => p.id = pruefungId) }
        let response: CRUDPruefungResponse = await ajaxAsync('/servlet/crudPruefung', request);
        if (response.success) {
            this.onUnselectPruefung();
            this.pruefungen.splice(this.pruefungen.findIndex(p => p.id == pruefungId), 1);
        }
    }

    addPruefung() {
        NewPruefungPopup.open(this.klassen, this.workspaces.filter(ws => !ws.isFolder), () => { },
            async (pruefung: Pruefung) => {
                let request: CRUDPruefungRequest = { requestType: "create", pruefung: pruefung }
                let response: CRUDPruefungResponse = await ajaxAsync('/servlet/crudPruefung', request);
                if (response.success) {
                    this.pruefungTable.add(response.newPruefungWithIds);
                    this.pruefungen.push(response.newPruefungWithIds);
                    this.pruefungTable.select(response.newPruefungWithIds.id);
                }
            }, this.administration.application);
    }

    async print() {
        let request: GetPruefungForPrintingRequest = { pruefungId: this.currentPruefung.id };

        let p = await ajaxAsync("/servlet/getPruefungForPrinting", request) as GetPruefungForPrintingResponse;

        if (p == null) return;

        let $printingDiv = jQuery('#print');
        $printingDiv.empty();

        p.pSchuelerDataList = p.pSchuelerDataList.sort((sda, sdb) => {
            if (sda.familienname != sdb.familienname) return sda.familienname.localeCompare(sdb.familienname);
            return sda.rufname.localeCompare(sdb.rufname);
        })

        let klasse = this.klassen.find(k => k.id == this.currentPruefung.klasse_id).text;

        let datumText = this.currentPruefung.datum == null ? "" : ", " +
            w2utils.formatDate(this.currentPruefung.datum, 'dd.mm.yyyy');

        for (let sd of p.pSchuelerDataList) {
            $printingDiv.append(`<h1>${sd.familienname}, ${sd.rufname} (${AdminMessages.classWord()} ${klasse})</h1>`);
            $printingDiv.append(`<h1>${this.currentPruefung.name}${datumText}</h1>`);

            let markText = "";
            if (sd.grade != null && sd.grade != "") {
                markText += AdminMessages.mark() + ": " + sd.grade;
            }

            if (sd.points != null && sd.points != "") {
                let pointsText = sd.points + " " + AdminMessages.points()
                if (markText != "") {
                    pointsText = " (" + pointsText + ")"
                }
                markText += pointsText;
            }

            if (markText != "") {
                $printingDiv.append(`<h2>${markText}</h2>`);
            }

            if (sd.comment != null && sd.comment != "") {
                $printingDiv.append(`<h3>${AdminMessages.comment()}: </h3>`);
                $printingDiv.append(`<div style="white-space: pre-wrap;">${sd.comment}</div>`);
            }

            for (let f of sd.files) {

                makeDiv(null, 'jo_fileCaption', AdminMessages.file() + f.name, null, $printingDiv);

                if (f.text_before_revision != null) {
                    let $twoColumnDiv = makeDiv(null, 'jo_twoColumnDiv', null, null, $printingDiv);
                    let $leftDiv = makeDiv(null, 'jo_leftColumn', null, null, $twoColumnDiv);
                    let $rightDiv = makeDiv(null, 'jo_rightColumn', null, null, $twoColumnDiv);

                    makeDiv(null, 'jo_originalCaption', AdminMessages.studentsFile(), null, $leftDiv);
                    makeDiv(null, 'jo_originalCaption', AdminMessages.correction() + ':', null, $rightDiv);

                    let $codeLeft = makeDiv(null, 'jo_codeBlock', null, null, $leftDiv);
                    this.insertCodeIntoDiv(f.text_before_revision, $codeLeft);

                    let $codeRight = makeDiv(null, 'jo_codeBlock', null, null, $rightDiv);
                    this.insertCodeIntoDiv(f.text, $codeRight);

                } else {
                    let $leftDiv = makeDiv(null, 'jo_leftColumn', null, null, $printingDiv);

                    let $codeLeft = makeDiv(null, 'jo_codeBlock', null, null, $leftDiv);
                    this.insertCodeIntoDiv(f.text, $codeLeft);

                }

            }

            makeDiv(null, 'jo_pagebreak', null, null, $printingDiv);
        }

        window.print();

    }

    insertCodeIntoDiv(code: string, div: JQuery<HTMLElement>) {
        let code1 = code;

        let lines = code.split("\n");
        let length = lines.length;

        if (lines.length > 10000) {
            lines = lines.slice(0, 10000);
            lines.unshift("Der Code war " + length + " Zeilen lang und wurde auf 10000 Zeilen gekürzt, da er zu lang für die Anzeige ist. Den vollständigen Code finden Sie in der Korrekturansicht.");
        }

        for (let line of lines) {
            makeDiv(null, null, line, null, div);
        }
    }

    onUpdatePruefung(event: any) {

        let data: Pruefung = <Pruefung>this.pruefungTable.records[event.detail.index];

        let field = this.pruefungTable.columns[event.detail.column]["field"];

        let oldData: any;

        switch (field) {
            case "name":
                oldData = data[field];
                data[field] = event.detail.value.new;
                break;
            case "klasse_id":
                if (data.state != this.states[0]) {
                    alert(AdminMessages.alterClassOnlyInStatePreparation());
                    event.isCancelled = true;
                    return;
                }
                oldData = data[field];
                data[field] = event.detail.value.new.id;
                break;
            case "datum":
                oldData = data[field];
                data[field] = event.detail.value.new;
                break;
            case "template_workspace_id":
                if (data.state != this.states[0]) {
                    alert(AdminMessages.alterTemplateWorkspaceOnlyInStatePreparation());
                    event.isCancelled = true;
                    return;
                }
                oldData = data[field];
                data[field] = event.detail.value.new.id;
                break;
        }

        let request: CRUDPruefungRequest = { requestType: "update", pruefung: data }
        ajax('/crudPruefung', request, (response: CRUDPruefungResponse) => {
            if (response.success == true) {
                delete data["w2ui"]["changes"][field];
                this.pruefungTable.refreshCell(data["recid"], field);

            } else {
                data[field] = event.detail.value.original;
                delete data["w2ui"]["changes"][field];
                this.pruefungTable.refreshCell(data["recid"], field);
            }
        });



    }

    async onUpdateStudent(event: any) {

        let data = <PSchuelerData>this.studentTable.records[event.detail.index];

        let field = this.studentTable.columns[event.detail.column]["field"];

        let oldData = data[field];
        data[field] = event.detail.value.new;

        let request: UpdatePruefungSchuelerDataRequest = {
            pruefungId: this.currentPruefung.id,
            schuelerId: data.id,
            grade: data.grade,
            points: data.points,
            attributesToUpdate: field,
            mode: (typeof data.mode == 'string' ? data.mode : data.mode.id) as PruefungStudentMode,
            group: (typeof data.group == 'string' ? data.group : data.group.id)
        }

        let response: BaseResponse = await ajaxAsync('/servlet/updatePruefungSchuelerData', request);

        if (response.success == true) {
            if (data["w2ui"] && data["w2ui"]["changes"]) {
                delete data["w2ui"]["changes"][field];
            }
            this.studentTable.refreshCell(data["recid"], field);

        } else {
            data[field] = event.detail.value.original;
            if (data["w2ui"] && data["w2ui"]["changes"]) {
                delete data["w2ui"]["changes"][field];
            }
            this.studentTable.refreshCell(data["recid"], field);
        }

    }

    renderState() {
        this.$stateDiv.find('.pruefungState').css({ "border-bottom": "none", "color": "inherit", "font-weight": "unset" });
        this.$stateDiv.find("#joe_z" + this.selectedStateIndex).css({
            "border-bottom": "2px solid #30ff30",
            "color": "#0000b0",
            "font-weight": "bold"
        })

        this.buttonForward.setActive(this.isTransitionAllowed(this.selectedStateIndex + 1));
        this.buttonBack.setActive(this.isTransitionAllowed(this.selectedStateIndex - 1));

        let groupCol = this.studentTable.columns.find(c => c.field == 'group');
        if (this.currentPruefung.state == 'preparing') {
            groupCol.editable = groupCol.editable1;
            groupCol.style = 'color: inherit;'
        } else {
            groupCol.editable = false;
            groupCol.style = 'color: #a0a0a0;'
        }

        this.studentTable.refresh();

        this.fieldGroupA.el.disabled = this.currentPruefung.state != 'preparing';
        this.fieldGroupB.el.disabled = this.currentPruefung.state != 'preparing';

    }

    /* only transitions preparing -> running <-> correcting -> opening possible
   running -> preparing is possible only if template hasn't been copied to student-workspaces */
    isTransitionAllowed(newStateIndex: number): boolean {
        if (newStateIndex == this.selectedStateIndex) return true;
        if (newStateIndex < 0 || newStateIndex > this.states.length - 1) return false;

        if (newStateIndex == this.stateIndex.preparing && this.selectedStateIndex == this.stateIndex.running) return false;

        if (Math.abs(newStateIndex - this.selectedStateIndex) > 1) return false;

        return true;
    }


    async fillPruefungTable() {
        this.pruefungTable.add(this.pruefungen);
        this.pruefungTable.refresh();
    }

    async onSelectPruefung(recId: number) {
        if (typeof recId == 'undefined') return;
        this.currentPruefung = <any>this.pruefungTable.records.find(p => p["recid"] == recId);

        let request: GetPruefungStudentTableDataRequest = { pruefung_id: recId };

        let p = await ajaxAsync("/servlet/getPruefungStudentTableData", request) as GetPruefungStudentTableDataResponse;

        for (let sd of p.studentDataList) {
            sd.mode = { id: <PruefungStudentMode>sd.mode, text: AdminMessages.modeToText(<string>sd.mode) };
            sd.group = sd.group == null ? { id: "A", text: "A" } : { id: <string>sd.group, text: <string>sd.group };
        }

        this.studentTable.unlock();
        this.studentTable.clear();
        this.studentTable.add(p.studentDataList);
        // this.studentTable.refresh();


        this.fieldGroupA.set(this.workspaces.find(ws => ws.id == (this.currentPruefung.template_workspace_a_id || -1)));
        this.fieldGroupB.set(this.workspaces.find(ws => ws.id == (this.currentPruefung.template_workspace_b_id || -1)));


        this.selectedStateIndex = this.states.indexOf(this.currentPruefung.state);
        this.renderState();
        jQuery('#pruefungActions').removeClass('jo_inactive');
    }

    onUnselectPruefung() {
        jQuery('#pruefungActions').addClass('jo_inactive');
        this.studentTable.clear();
        this.studentTable.lock(AdminMessages.noTestSelected(), false);
    }

    async savePruefung(): Promise<boolean> {

        let request: CRUDPruefungRequest = { requestType: "update", pruefung: this.currentPruefung }
        let response: CRUDPruefungResponse = await ajaxAsync('/servlet/crudPruefung', request);

        return response.success;

    }


    compareWithPath(name1: string, path1: string[], name2: string, path2: string[]) {

        path1 = path1.slice();
        path1.push(name1);
        name1 = "";

        path2 = path2.slice();
        path2.push(name2);
        name2 = "";

        if (path1[0] == '_Prüfungen' && path2[0] != '_Prüfungen') return 1;
        if (path2[0] == '_Prüfungen' && path1[0] != '_Prüfungen') return -1;

        let i = 0;
        while (i < path1.length && i < path2.length) {
            let cmp = path1[i].localeCompare(path2[i]);
            if (cmp != 0) return cmp;
            i++;
        }

        if (path1.length < path2.length) return -1;
        if (path1.length > path2.length) return 1;

        return name1.localeCompare(name2);


        // let nameWithPath1 = path1.join("/");
        // if (nameWithPath1 != "" && name1 != "") nameWithPath1 += "/";
        // nameWithPath1 += name1;

        // let nameWithPath2 = path2.join("/");
        // if (nameWithPath2 != "" && name2 != "") nameWithPath2 += "/";
        // nameWithPath2 += name2;

        // return nameWithPath1.localeCompare(nameWithPath2);
    }

}
